import React from 'react';
import { PageHeader } from '../components/shared/PageHeader';
import { ProductCard } from '../components/shared/ProductCard';
import { products } from '../data/products';
import { images } from '../data/images';
export function Products() {
  return <>
      <PageHeader crumb="Products" title="Our Products" subtitle="Paper cores and stretch film made in Umm Al Quwain, plus the films, papers and accessories that go with them. Every product is quoted to your specification." image={images.shrinkFilm} data-id="element-382" data-mp="3kvh9mb6163jp" />

      <section className="bg-ink py-16 md:py-20" data-id="element-383" data-mp="2n7z376zuddiv">
        <div className="mx-auto grid max-w-[1320px] gap-6 px-5 sm:grid-cols-2 md:px-8 lg:grid-cols-3" data-id="element-384" data-mp="323ey1e88xdgb">
          {products.map(product => <ProductCard key={product.slug} product={product} data-id="element-385" data-mp="2x651lemfw1iz" />)}
        </div>
      </section>
    </>;
}